import { useState } from 'react';

export const useImageUpload = () => {
  const [imagePreview, setImagePreview] = useState(null);
  const [imageFile, setImageFile] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    
    if (!file) return;

    // Validar tipo de arquivo
    if (!file.type.startsWith('image/')) {
      alert('Por favor, selecione apenas arquivos de imagem.');
      return;
    }

    // Validar tamanho (máximo 5MB)
    const maxSize = 5 * 1024 * 1024; // 5MB
    if (file.size > maxSize) {
      alert('A imagem deve ter no máximo 5MB.');
      return;
    }

    setImageFile(file);

    // Criar preview
    const reader = new FileReader();
    reader.onload = (e) => {
      setImagePreview(e.target.result);
    };
    reader.readAsDataURL(file);
  };

  const removeImage = () => {
    setImagePreview(null);
    setImageFile(null);
  };

  const uploadImage = async () => {
    if (!imageFile) return null;

    setIsLoading(true);
    
    try {
      // Simular upload - em produção, aqui você faria o upload real
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      // Retornar dados simulados do upload
      return {
        success: true,
        url: imagePreview,
        filename: imageFile.name
      };
    } catch (error) {
      return {
        success: false,
        error: error.message
      };
    } finally {
      setIsLoading(false);
    }
  };

  return {
    imagePreview,
    imageFile,
    isLoading,
    handleImageChange,
    removeImage,
    uploadImage
  };
};
